import { NgModule } from '@angular/core';

import { AvatarComponent } from './avatar.component';
import { defaultBackgroundColor, pickColorForName } from './color-generator';
import { AvatarGroupComponent, AvatarGroupItem } from './avatar-group/avatar-group.component';

export { AvatarComponent, defaultBackgroundColor, pickColorForName };

export { AvatarGroupComponent, AvatarGroupItem };

@NgModule({
  imports: [AvatarComponent, AvatarGroupComponent],
  exports: [AvatarComponent, AvatarGroupComponent],
})
export class GalaxyAvatarModule {}
